<template>
  <AboutDirectSchool :title="title" :locations="locations" :people="people" />
</template>

<script>
import AboutDirectSchool from "@/components/AboutDirectSchool.vue";

export default {
  components: {
    AboutDirectSchool
  },
  data() {
    return {
      title: "西區校  國中部/高中部",
      locations: [
        {
          name: "A棟",
          description: "國中部",
          photo: require("../assets/west-2-a-building-photo.jpg"),
          address: "台中市西區三民路一段172-6號",
          phone: "04-2229-9399"
        },
        {
          name: "B棟",
          description: "高中部",
          photo: require("../assets/west-2-high-school-photo.jpg"),
          address: "台中市西區三民路一段166-2號",
          phone: "04 2225-1089"
        }
      ],
      people: [
        {
          title: "國中部主任 ",
          photo: require("../assets/west-2-junior-high-school-director.png"),
          name: "莊雅婷"
        },
        {
          title: "高中部主任",
          photo: require("../assets/west-2-high-school-director.png"),
          name: "陳淑勤"
        }
      ]
    };
  }
};
</script>

<style></style>
